<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import BaseLink from '../BaseLink/BaseLink.svelte';

  let {
    headingText,
    headingLevel = 'h2',
    childLinks = [],
    currentPath,
    className = '',
    filterProviders = () => {},
    dataTestId = 'filter-tabs',
  } = $props();

  let showDropdown = $state(false);
  const toggleDropdown = (e) => {
    if (e.type === 'click') {
      showDropdown = !showDropdown;
    }
  };
</script>

<nav
  data-testid={dataTestId}
  class={`bg-gray-mercury mb-4 ${childLinks.length > 5 ? 'lg:bg-white lg:border-blue-cerulean lg:border-b-4' : 'md:bg-white md:border-blue-cerulean md:border-b-4'} lg:mb-6 ${className}`}
>
  <button
    onclick={toggleDropdown}
    class="px-4 py-3 w-full flex justify-between focus:shadow-inset-focus active:shadow-inset-active bg-blue-bright-cyan hover-hover:hover:bg-blue-robin-egg active:bg-blue-robin-egg 
    {childLinks.length > 5 ? 'lg:hidden' : 'md:hidden'}"
    aria-expanded={showDropdown}
  >
    <BaseHeading
      className="text-blue-dark-navy font-semibold text-left"
      {headingLevel}
      dataTestId="{dataTestId}-base-heading"
    >
      {headingText}
    </BaseHeading>
    <svg
      class="w-6 h-6 fill-current transition-transform duration-200 ease-in-out"
      class:rotate-90={!showDropdown}
      class:-rotate-90={showDropdown}
    >
      <use xlink:href={`${SPRITESHEET_URL}chevron-right`} />
    </svg>
  </button>
  <!-- desktop -->
  <ul
    class="shadow-md overflow-hidden transition-height duration-150 ease-in-out {childLinks.length > 5
      ? 'lg:shadow-none lg:max-h-full lg:max-w-6xl lg:mx-auto lg:flex'
      : 'md:shadow-none md:max-h-full md:max-w-6xl md:mx-auto md:flex'}"
    class:max-h-0={!showDropdown}
    class:max-h-auto={showDropdown}
  >
    {#each childLinks as link, index (index)}
      <li class="md:mr-12">
        {#if currentPath === link.url || currentPath === link.text}
          <p
            class="px-4 py-3 font-semibold {childLinks.length > 5
              ? 'lg:pt-0 lg:px-0 lg:text-blue-cerulean'
              : 'md:pt-0 md:pb-1 md:px-0 md:text-blue-cerulean'}"
          >
            {link.text}
          </p>
          <div class="hidden md:block mx-auto w-0 h-0 border-l-8 border-l-transparent border-b-8 border-b-blue-cerulean border-r-8 border-r-transparent"></div>
        {:else}
          {#if link.url}
            <BaseLink
              url={link.url}
              target={link.target}
              className="w-full group flex items-center justify-between px-4 py-3 text-blue-cerulean font-semibold text-center hover-hover:hover:text-blue-darkish hover-hover:hover:underline active:text-blue-darkish active:underline 
              {childLinks.length > 5
                ? 'lg:pt-0 lg:px-0 lg:hover:text-blue-cerulean lg:font-normal lg:text-blue-dark-navy'
                : 'md:pt-0 md:px-0 md:hover:text-blue-cerulean md:font-normal md:text-blue-dark-navy'}"
            >
              {link.text}
            </BaseLink>
          {:else}
            <button class="w-full group flex items-center justify-between px-4 py-3 text-blue-cerulean font-semibold text-center hover-hover:hover:text-blue-darkish 
              hover-hover:hover:underline active:text-blue-darkish active:underline 
              {childLinks.length > 5
                ? 'lg:pt-0 lg:px-0 lg:hover:text-blue-cerulean lg:font-normal lg:text-blue-dark-navy'
                : 'md:pt-0 md:px-0 md:hover:text-blue-cerulean md:font-normal md:text-blue-dark-navy'}"
              onclick={() => filterProviders(link.action)}
            >
              {link.text}
            </button>
          {/if}
        {/if}
      </li>
    {/each}
  </ul>
</nav>
